/**
 * Separate the names and domains of queues or agents
 */
export default function idealName(name: string): string {
    return name?.split('@').shift() || '';
}
